module.exports = __webpack_public_path__ + "img/xddq-currency-guide-1.a8d32f7c.png";